'use client'

import { Button } from '@heroui/react'
import { useTheme } from '@/contexts/theme-context'
import { SunLight, MoonSat, Computer } from 'iconoir-react'

export function ThemeToggle() {
  const { theme, setTheme } = useTheme()

  const cycleTheme = () => {
    if (theme === 'light') {
      setTheme('dark')
    } else if (theme === 'dark') {
      setTheme('system')
    } else {
      setTheme('light')
    }
  }

  const getIcon = () => {
    if (theme === 'light') {
      return <SunLight className="w-5 h-5" />
    } else if (theme === 'dark') {
      return <MoonSat className="w-5 h-5" />
    } else {
      return <Computer className="w-5 h-5" />
    }
  }

  const getLabel = () => {
    if (theme === 'light') {
      return 'Light mode'
    } else if (theme === 'dark') {
      return 'Dark mode'
    } else {
      return 'System theme'
    }
  }

  return (
    <Button
      isIconOnly
      variant="light"
      onPress={cycleTheme}
      aria-label={getLabel()}
      title={getLabel()}
    >
      {getIcon()}
    </Button>
  )
}

